import React, { useEffect, useState } from "react";
import { View, Text, StyleSheet, Image } from "react-native";
import Colours from "../../utils/Colours";
import MenuBar from "../../icons/MenuBar";
import MoneyIcon from "../../icons/MoneyIcon";

const TopHeaderProfile = () => {
  return (
    <View style={styles.topHeaderContainer}>
      {/* <BackArrow color={Colours.DARKGRAY} /> */}
      <Text style={{ fontSize: 20, color: Colours.DARKGRAY, fontFamily: "Sen-Bold" }}>Profile</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  topHeaderContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    //   backgroundColor: "#12ff34",
    alignItems: "center",
    padding: 15,
    paddingTop: 20,
  },
});

export default TopHeaderProfile;
